module.exports = __webpack_public_path__ + "img/left-hem.f5a0be56.gif";